import { useQueryClient } from '@tanstack/react-query';
import { useOptimisticMutation } from '../../../hooks/use-optimistic-mutation';
import type { CustomerLookup } from '../types/api';
import type { Customer } from '../types/customer';
import { useCustomersApi } from './use-customers-api';
import { QK_GET_CUSTOMER } from './use-get-customer';

// Partially updates a customer (e.g. role selection or related fields)
export function useUpdateCustomer({ lookup }: { lookup: CustomerLookup }) {
  const queryClient = useQueryClient();
  const { customersApi } = useCustomersApi();

  return useOptimisticMutation<Partial<Customer>, Partial<Customer>>({
    queryClient,
    queryKey: QK_GET_CUSTOMER(lookup),
    mutationFn: (payload) => customersApi.customer(lookup).update(payload),
    optimisticUpdate: (prev, payload) => {
      if (!prev) {
        return payload;
      }
      return { ...prev, ...payload };
    },
  });
}
